import React from "react";


import CssBaseline from "@mui/material/CssBaseline";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { ThemeProvider } from "@mui/material/styles";
import logoEU from "../../assets/images/euro.png";


import ConfirmCard from "./ConfirmCard"
import theme from "../../theme";


export default function Auth() {


  
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage:
              'url("/static/images/templates/templates-images/sign-in-side-bg.png")',
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          > */}
          {/* <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{
                width: "40%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Box
              component="img"
              src={logoEU}
              alt="logo"
              sx={{
                width: "40%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box>
        </Grid>
        
        <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <ConfirmCard/>
          </Grid> 
      <Grid container>
        
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
